export const locale = {
    lang: 'de',
    data: {
        PROJECTS: 'Projekte',
        BASE: 'Stammdaten',
        DOCS: 'Dokumente',
        INVOLVED: 'Beteiligte',
        TASKS: 'Arbeitspakete',
        KANBAN: 'Kanban',
        NOTES: 'Notizen',
        NEW: 'Neuen Beteiligten hinzufügen',
        PROJECTNUMBER: 'Projektnummer',
        COLUMNS: {
            NAME: 'Name',
            KIND: 'Art',
            INTERN: 'Intern',
            EXTERN: 'Extern',
            PARTICIPATION: 'Beteiligung',
            INPERCENT: '(in %)',
            START: 'Start',
            END: 'Ende',
            USER: 'User (AD)',
            PROJECT: 'Projekt',
            SAVE: 'Speichern',
        },
    },
};
